module.exports = __webpack_public_path__ + "img/wangyan.ab19966a.jpg";